var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004d78",
    d: "M16.42 10.198H7.627a.604.604 0 0 0-.442.186.603.603 0 0 0-.186.442c0 .17.062.317.186.44l4.396 4.397a.605.605 0 0 0 .442.187c.17 0 .317-.063.441-.187l4.396-4.396a.603.603 0 0 0 .186-.441.603.603 0 0 0-.186-.442.601.601 0 0 0-.442-.186z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilerRed);
export default __webpack_public_path__ + "static/media/filer-red.eee36832106c7de290f02f8bb761fdca.svg";
export { ForwardRef as ReactComponent };